import React from 'react'

import { Partners, /* Scenario, */ Cooperation } from 'components'
import { Separator } from 'shared/components'
import {
  FirstBlock,
  Counts,
  /*Investments, */ Originals,
  Priority,
} from './blocks'

export const Home = (): JSX.Element => {
  return (
    <>
      {/* для seo */}
      <h1 className="hidden">
        Дистрибуция и производство оригинальных фильмов и сериалов
      </h1>

      <FirstBlock />
      <Priority />
      <Counts />
      <Originals />
      {/*<Scenario screenName="/main" />*/}
      {/*<Investments />*/}
      <Cooperation page="home" />
      <Partners />
      <Separator height={60} />
    </>
  )
}
